import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core'
import { DataService } from '../services/data/data.service'

@Directive({
  selector: '[sarboPermissionsNeeded]',
  standalone: true,
})
export class PermissionBasedAccessDirective implements OnInit {
  @Input() sarboPermissionsNeeded: string[]

  constructor(
    private readonly element: ElementRef,
    private readonly renderer: Renderer2,
    private readonly dataService: DataService,
  ) {}

  ngOnInit(): void {
    this.checkPermissions()
  }

  private checkPermissions(): void {
    const tempPermissions = this.dataService.getItem('permissions')
    const userPermissions = tempPermissions ? JSON.parse(tempPermissions) : undefined

    if (!userPermissions || !this.sarboPermissionsNeeded) {
      this.hide()
    } else if (this.sarboPermissionsNeeded.length > 0) {
      const hasPermission = this.sarboPermissionsNeeded.some((x) => userPermissions.includes(x))
      if (!hasPermission) {
        this.hide()
      }
    }
  }

  /**
   * Hides the host element from users lacking the required permissions.
   */
  private hide(): void {
    this.renderer.addClass(this.element.nativeElement, 'hidden')
    this.renderer.setStyle(this.element.nativeElement, 'display', 'none')
  }
}
